module.exports = __webpack_public_path__ + "img/scene5-12.96272a49.jpg";